<template>
    <div>
        <entity-overview entity-type="Quiz"></entity-overview>
    </div>
</template>

<script>
export default {
    name: 'QuizView'
};
</script>
